<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title"> Manage Users</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal hover-white" @click="openCreateModal('createModal')">
          <i class="fa fa-plus fs-11"></i> Add New User
        </button>
        <!-- NEW -->
        <button class="btn btn-md btn-outline-secondary hover-white fs-11 fw-normal"
          @click="$router.push({ name: 'user.import' })">
          <i class="fa fa-upload fs-11"></i> Import Users
        </button>

        <!-- <button type="button" class="btn btn-md btn-outline-primary fs-11 fw-normal text-primary hover-white"> <i
            class="fa fa-list fs-11 text-primary hover-white "></i> Users List</button> -->
      </div>
    </div>
    <!-- Sirf Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
    <div class="card p-1 bg-white">


      <!-- Modal with CreateUser inside slot -->
      <FormModal ref="createModal" title="Create New User" id="create_user_form_modal">
        <CreateUser :roles="roles" @click="f" ref="createUserForm" @created="onUserCreated"
          @close="closeCreateModal('createModal')" />
      </FormModal>
      <FormModal ref="editModal" title="Edit User" id="edit_user_form_modal">
        <EditUser :roles="roles" @created="fetchUsers" :user="selectedUser" ref="editUserForm" @updated="onUpdated"
          @close="closeEditModal('editModal')" />
      </FormModal>

      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading Users..." />

      <!-- Users Table -->
      <div v-else class="table-wrapper ">
        <ListTable>
          <colgroup>
            <!-- <col style="width: 6%"> -->
            <col style="width: 25%"> <!-- User -->
            <col style="width: 22%"> <!-- Email -->
            <col style="width: 14%"> <!-- Phone -->
            <col style="width: 12%"> <!-- Role -->
            <col style="width: 15%"> <!-- Created On -->
            <col style="width: 8%"> <!-- Action -->
          </colgroup>
          <thead>
            <tr>
              <!-- <th>SR#</th> -->
              <th @click="sortBy('first_name')" class="sortable">
                User <i :class="getSortIcon('first_name')"></i>
              </th>


              <th @click="sortBy('email')" class="sortable">
                Email <i :class="getSortIcon('email')"></i>
              </th>
              <th @click="sortBy('phone')" class="sortable">
                Phone <i :class="getSortIcon('phone')"></i>
              </th>
              <th>Role</th>
              <th>Created On</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in sortedData" :key="user.external_id">

              <!-- <td>
                  {{ index + 1 }}
              </td> -->

              <td class="align-middle">
                <div class="d-flex align-items-center gap-2" @click.prevent="profile(user.external_id)"  style="cursor: pointer;">
                  <div
                    class="d-flex align-items-center justify-content-center bg-primary-subtle border border-primary-subtle rounded-3"
                    style="width: 40px; height: 40px; min-width: 40px;">
                    <img v-if="user.photo" :src="user.photo" width="40" height="40" class="rounded-circle">

                    <span v-else class="material-symbols-outlined text-primary fs-9">person</span>
                  </div>
                  <div>
                    <div class="text-dark">{{ user.first_name }} {{ user.last_name }}</div>
                    <div class="text-muted small">{{ user.external_id }}</div>
                  </div>
                </div>
              </td>

              <td>{{ user.email }}</td>
              <td>{{ user.phone }}</td>
              <td>
                <span class="badge fs-10 px-3 text-dark" style="background-color: #e3f2fd;">
                  {{ user.get_current_company_role?.name || 'N/A' }}
                </span>
              </td>
              <td>{{ user.created_at }}</td>
              <td>
                <TableActionDropdown>
                  <li>
                    <a class="dropdown-item" @click.prevent="profile(user.external_id)">
                      <i class="fa fa-eye text-info"></i>
                      <span>Profile</span>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" @click.prevent="edit(user)">
                      <i class="fa fa-pencil text-primary"></i>
                      <span>Edit</span>
                    </a>
                  </li>
                    <hr class="dropdown-divider" />
                
                  <li>
                    <a class="dropdown-item item-danger" @click.prevent="deleteProfile(user)">
                      <i class="fa fa-trash"></i>
                      <span>Delete</span>
                    </a>
                  </li>
                </TableActionDropdown>

              </td>
            </tr>
            <tr v-if="sortedData.length === 0">
              <td colspan="7" class="text-center">No users found</td>
            </tr>

          </tbody>
        </ListTable>
      </div>

      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
  <ConfirmDeleteModal
  v-model="showDeleteModal"
  :item-name="deletingUser?.first_name + ' ' + deletingUser?.last_name"
  :loading="deleting"
  title="Delete User"
  message="Are you sure you want to delete"
  @confirm="confirmDelete"
/>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateUser from '@/views/User/CreateUser.vue'
import ListTable from '@/components/utils/ListTable.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'
import EditUser from '@/views/User/EditUser.vue'
import ConfirmDeleteModal from '@/components/utils/ConfirmDeleteModal.vue'

export default {
  name: 'UserList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateUser,
    ListTable,
    TableActionDropdown,
    EditUser, ConfirmDeleteModal 
  },
  data() {
    return {
      users: [],
      roles: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filterManager: null,
      sortColumn: null,
      sortOrder: 'asc',
      filteredData: [],
      currentFilters: {},
      showDeleteModal: false,
      deletingUser:    null,
      deleting:        false,
    }
  },
  computed: {

    // Sorted data
    sortedData() {
      let result = [...this.filteredData];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() { //doc read
    // alert(localStorage.getItem('user_token'));
    this.fetchUsers()
    this.fetchRoles()
    this.$nextTick(() => {
      setTimeout(() => {
        this.initFilters();
      }, 1000);
    });

  },
  methods: {
    async fetchRoles() {
      this.loading = true

      try {
        const result = await form_api_submit({
          url: 'roles/get-roles',
          method: 'GET',
          show_success_toast: false,
          show_error_toast: true
        })

        if (result.success) {
          this.roles = result.data || []
        }

      } finally {
        this.loading = false
      }
    },
    openCreateModal(ref) {
      this.$refs[ref].showModal()

    },

    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },

    async onUserCreated() {
      this.pagination.current_page = 1
      await this.fetchUsers()
    },

    async fetchUsers() {
      this.loading = true

      const result = await form_api_submit({
        url: 'list',
        method: 'GET',
        data: {
          page: this.pagination.current_page,
          ...this.currentFilters
        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        console.log(result);
        this.users = result.data.list
        this.filteredData = [...result.data.list]
        this.pagination = result.data.pagination

      }

      this.loading = false
    },


    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      // alert(this.pagination.current_page);
      this.fetchUsers()
    },
    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      const roleOptions = (this.roles || []).map(role => ({
        value: String(role.id),
        label: role.name
      }));

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "id",
            label: "ID",
            type: "input",
            placeholder: "Filter by ID"
          },
          {
            key: "name",
            label: "Name",
            type: "input",
            placeholder: "Filter by Name"
          },
          {
            key: "role",
            label: "Role",
            type: "checkbox",
            options: roleOptions
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchUsers();
    },
    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchUsers();
    },
    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.currentFilters = {};
      this.sortColumn = null;
      this.sortOrder = 'asc';
      this.pagination.current_page = 1;
      this.fetchUsers();
    },
    // Sorting method
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination(); // Reset to first page when sorting changes
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
    profile(external_id) {
      this.$router.push({
        name: 'user.profile',
        params: {
          external_id: external_id
        }
      })
    },
    getRoleBadgeColor(roleName) {
      const colors = {
        'admin': '#e3f2fd',        // light blue
        'manager': '#e8f5e8',      // light green
        'user': '#fff3e0',         // light orange
        'default': '#f8f9fa'       // light gray
      }
      const lowerRole = (roleName || '').toLowerCase()
      return colors[lowerRole] || colors.default
    },
    edit(user) {
      this.selectedUser = user
      this.$refs.editModal.showModal()
    },
    closeEditModal(ref) {
      this.$refs[ref].closeModal()
    },
  deleteProfile(user) {
    this.deletingUser    = user
    this.showDeleteModal = true
  },

  async confirmDelete() {
    this.deleting = true
    try {
      const result = await form_api_submit({
        url:   `user/delete/${this.deletingUser.id}`,
        method: 'POST',
        show_success_toast: true,
        show_error_toast:   true,
      })
      if (result.success) {
        this.showDeleteModal = false
        this.deletingUser    = null
        this.fetchUsers()
      }
    } finally {
      this.deleting = false
    }
  },
  }
}
</script>

<style scoped>
/* .card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
} */

.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}
</style>